// extracted by extract-css-chunks-webpack-plugin
module.exports = {"customLink":"_3B53C","noCursor":"_2AfHI"};